module.exports = __webpack_public_path__ + "static/img/partner6.6ae6292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner6.png
// module id = houY
// module chunks = 1